import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { CompanyService } from './company.service';
import { ProjectService } from './project.service';

@Injectable()
export class EnterpriseService {
  constructor(
    private http: Http,
    private companyService: CompanyService,
    private projectService: ProjectService
  ) {}

  private baseurl = environment.apiBaseUrl;

  // save entry in enterprise table corresponding to selected project with projectId
  save(projectId) {
    return this.http
      .post(`${this.baseurl}/enterprise/save`, { projectId })
      .map((response: Response) => response.json());
  }

  // update values of input fields of enterprise page onchange event
  updateValue(data) {
    return this.http
      .post(`${this.baseurl}/enterprise/update`, { data })
      .map((response: Response) => response.json());
  }

  // get all enterprise data from db corresponding to selected project
  getEnterpriseData(data) {
    return this.http
      .post(`${this.baseurl}/enterprise/getEnterpriseData`, { data })
      .map((response: Response) => response.json());
  }

  loadData(companyId, projectId): Observable<any> {
    const enterpriseData = { projectId };

    return Observable.forkJoin(
      this.getEnterpriseData(enterpriseData),
      this.companyService.getCompany(companyId),
      this.projectService.getProjectV2(projectId)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/enterprise.service.ts